export default {
    application: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    buttonIntegrations: {
        Production: true,
        PreProduction: true,
        UAT: true,
        SVT: true,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    }
};
